<div class="tab-pane show active fade details-view-results" id="trial-sites" role="tabpanel">
  <div class="details-view-results-head">
    <div class="flex justify-between">
      <app-search-input name="searchInput" [parentForm]="searchForm"></app-search-input>

      <app-button text="Assign Site" faIcon="fas fa-plus" href="/trial/{{ trialId }}/site/assign" size="sm"
        margin="lg" variant="info"
        [visible]="authService.hasPermission(Permissions.TrialSiteAssign)" />
    </div>
  </div>

  <table aria-hidden="true" class="details-view-sites with-heading-columns">
    <thead>
      <tr>
        <th style="width: 10%;">Site Number</th>
        <th>Site Name</th>
        <th>Site Address</th>
        <th style="width: 10%;">Site Status</th>
        <th style="width: 20%;"></th>
      </tr>
    </thead>
    <tbody *ngIf="dataLoaded">
      <tr *ngFor="let site of results.results">
        <td class="site-id"> {{ site.trials[0].siteNumber }} <span class="badge badge-info"
            *ngIf="site.apiConsumerId">{{ site.apiConsumerName }}</span></td>
        <td> {{ site.name }}</td>
        <td> {{ site.getFullAddress() }}</td>
        <td> {{ this.mapStatus(site.trials[0].approvalStatus) }}</td>
        <td class="text-right">
          <div class="flex justify-end gap-2">
            <app-button text="Edit" href="/trial/{{ trialId }}/site/{{ site.id }}/edit" size="sm"
              variant="secondary" [visible]="authService.hasPermission(Permissions.TrialSiteEdit)" />
            <app-button text="Unassign" (clicked)="onUnassignSite(site.id)" size="sm"
              variant="info" [visible]="authService.hasPermission(Permissions.TrialSiteUnassign)" />
          </div>
        </td>
      </tr>
    </tbody>

    <tbody *ngIf="!dataLoaded">
      <tr *ngFor="let _ of loaderArray">
        <td class="site-id" style="width: 10%;"><ngx-skeleton-loader class="d-block"
            style="width:60%;"></ngx-skeleton-loader></td>
        <td style="width: 15%;"><ngx-skeleton-loader class="d-block" style="width:70%;"></ngx-skeleton-loader></td>
        <td style="width: 55%;"><ngx-skeleton-loader class="d-block" style="width:40%;"></ngx-skeleton-loader></td>
        <td style="width: 10%;"><ngx-skeleton-loader class="d-block" style="width:50%;"></ngx-skeleton-loader></td>
        <td style="width: 20%;">
          <div class="flex justify-end gap-2" style="align-items:center;">
            <ngx-skeleton-loader class="d-inline-block"
              style="width:72px; height:32px; margin-left:8px; border-radius:6px;"></ngx-skeleton-loader>
            <ngx-skeleton-loader class="d-inline-block"
              style="width:92px; height:32px; margin-left:8px; border-radius:6px;"></ngx-skeleton-loader>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="no-results inside" *ngIf="dataLoaded && results.results.length == 0">
    <div class="inner">
      <div class="image">
        <img src="assets/img/no-results-illustration.png" alt="No results found" />
      </div>
      <div class="content">
        <h2>No Results Found</h2>
        <p>There are no sites assigned to this trial.</p>
      </div>
    </div>
  </div>

  <app-pagination [currentPage]="results.currentPage" [totalPageCount]="results.totalPageCount"
    (pageSelected)="loadSites($event)"></app-pagination>
</div>

<!-- Start: Unassign site modal -->
<app-modal *ngIf="dataLoaded" #unassignSiteModel customClassName="delete-site-modal">
  <div class="modal-header">
    <h2 class="modal-title">Unassign Site?</h2>
  </div>
  <div class="modal-body text-center">
    <div class="delete-modal-text">
      <p>Are you sure you want to unassign this site?</p>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="Cancel" (clicked)="unassignSiteModel.hide()" variant="secondary"
          [isBusy]="siteIsUnassigning" width="fill" />
      </div>

      <div class="col-6">
        <app-button text="Yes, unassign" (clicked)="onConfirmUnassignSite()" [isBusy]="siteIsUnassigning"
          width="fill" />
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Unassign sites modal -->